export default __webpack_public_path__ + "static/napraia-4ff2dbfb042768bc6961b772fdbb8077.jpg";